import { z } from "zod";
import { SystemEntity } from "@erp/shared-types";

export const SystemEntitySchema = z.object({
  entityType: z.nativeEnum(SystemEntity),
  entityId: z.uuid(),
});

// Small factory for specializations
export const entityOfType = <T extends SystemEntity>(type: T) =>
  SystemEntitySchema.extend({ entityType: z.literal(type) });
